export default __webpack_public_path__ + "img/eGdFSJfA.19150d22.svg";